import SeoTags from './SeoTags';

export default SeoTags;



// WEBPACK FOOTER //
// ./src/components/shared/SeoTags/index.js